<template>
    <AppModal :title="$t('labels.translation_products')" ref="modal" size="full">
        <WizardForm :steps="steps" @submit="hide" @click-next="handleClickNext" ref="wizardForm"/>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import WizardForm from "../../../../../../components/new/form/wizardForm/WizardForm.vue";
import { defineAsyncComponent } from 'vue';

export default {
    name: 'TranslateProductsContentModal',
    components: {
        AppModal, WizardForm
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            languages: [],
            productUuids: [],
            fieldsForTranslation: [
                { name: 'names', label: this.$t('labels.names'), selected: true },
                { name: 'descriptions', label: this.$t('labels.descriptions'), selected: true },
                { name: 'seos', label: this.$t('labels.seos'), selected: true },
            ],
            selectedFromLanguage: null,
            selectedToLanguages: null,
            mainLanguageAlias: null
        }
    },
    methods: {
        show(productUuids) {
            this.productUuids = productUuids;

            this.languages = this.integration.language_aliases.map(alias => ({
                label: this.$t(`languages.${alias}`),
                value: alias
            }));

            this.selectedFromLanguage = this.languages[0];
            this.mainLanguageAlias = this.selectedFromLanguage.value;
            
            if (this.languages.length === 2) {
                this.selectedToLanguages = this.languages[1];
            }

            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
            this.productUuids = [];
            this.selectedFromLanguage = null;
            this.selectedToLanguages = null;
            this.mainLanguageAlias = null;
            this.fieldsForTranslation.forEach(field => field.selected = true);
        },
        handleClickNext() {
            if (this.$refs.wizardForm.activeIndex === 1) {
                this.$refs.wizardForm.stepRefs[1].fetchProduct();
            }
        }
    },
    computed: {
        steps() {
            return [
                {
                    name: this.$t('translateProductsContentModal.steps.languageAndFieldsSelection'),
                    component: defineAsyncComponent(() => import('./steps/LanguageAndFieldsSelectionStep.vue')),
                    props: {
                        selectedFromLanguage: this.selectedFromLanguage,
                        selectedToLanguages: this.selectedToLanguages,
                        fieldsForTranslation: this.fieldsForTranslation,
                        languages: this.languages,
                        'onUpdate:selectedFromLanguage': (language) => {
                            this.selectedFromLanguage = language;
                        },
                        'onUpdate:selectedToLanguages': (languages) => {
                            this.selectedToLanguages = languages;
                        },
                        'onUpdate:fieldsForTranslation': (fields) => {
                            this.fieldsForTranslation = fields;
                        }
                    },
                },
                {
                    name: this.$t('translateProductsContentModal.steps.productsProcessing'),
                    component: defineAsyncComponent(() => import('./steps/ProductsProcessingStep.vue')),
                    props: {
                        productUuids: this.productUuids,
                        mainLanguageAlias: this.mainLanguageAlias,
                        selectedFromLanguage: this.selectedFromLanguage,
                        selectedToLanguages: this.selectedToLanguages,
                        fieldsForTranslation: this.fieldsForTranslation,
                        'onProcessing-complete': () => {
                            this.hide();
                        }
                    }
                }
            ]
        }
    }
}
</script>